import { lazy } from 'react';


export const protectedRoutes = [
  {
    path: '/',
    name: 'Home',
    component: lazy(() => import('@/pages/twin-list/Twins')),
  },
  {
    path: '/twin-chat',
    name: 'Chat',
    component: lazy(() => import('@/pages/twinconversation/TwinChat')),
  },
  {
    path: '/twin-video-chat',
    name: 'Chat',
    component: lazy(() => import('@/pages/twinvideochat')),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: lazy(() => import('@/pages/profile/Profile')),
  },
  {
    path: '/buy-points',
    name: 'Buy Points',
    component: lazy(() => import('@/pages/buy-points/BuyPoints')),
  },
  {
    routeKey: 'payment_status',
    path: '/payment',
    name: 'Payment Status',
    component: lazy(() => import('@/pages/buy-points/components/PaymentStatus')),
  },
  {
    // routeKey: 'chat_history',
    path: '/chat-history',
    name: 'Chat History',
    component: lazy(() => import('@/pages/chat-history/ChatHistory')),
 },
 {
    path: '/conversation-history/:conversationId',
    name: 'Conversation History',
    component: lazy(() => import('@/pages/chat-history/ChatConversation')),
 },
];

export const protectedRouteNames = protectedRoutes.map((route) => route.name);

export const protectedRoutePaths = protectedRoutes.map((route) => route.path);

export default protectedRoutes;
